/** Typy punktów sprzedaży, dla których można ustawić osobną stawkę prowizji. */
export const OUTLET_KINDS = ['roomService', 'productsServices', 'productRental', 'spa', 'breakfastService'] as const;

export type OutletKind = (typeof OUTLET_KINDS)[number];

export const OUTLET_KIND_LABELS: Record<OutletKind, string> = {
  roomService: 'Room service',
  productsServices: 'Sklep / usługi',
  productRental: 'Wypożyczalnia',
  spa: 'Spa',
  breakfastService: 'Serwis śniadaniowy',
};

export interface HotelStripeFees {
  /** Stawka domyślna hotelu — obowiązuje typy bez własnego wpisu. */
  feePercent: number;
  /** Stawki per typ punktu. Brak klucza = dziedziczy stawkę domyślną. */
  feeByKind: Partial<Record<OutletKind, number>>;
  /**
   * Płatności online UDOSTĘPNIONE hotelowi przez HotelSpot (`hotels/{id}.stripePaymentsAvailable`).
   * Dopóki `false`, hotel nie widzi w panelu kafelka integracji Stripe.
   */
  paymentsAvailable: boolean;
  /** Hotel je WŁĄCZYŁ, akceptując regulamin. Bez udostępnienia nie ma czego włączyć. */
  paymentsEnabled: boolean;
  /** Kto zaakceptował regulamin (nazwisko albo e-mail, w ostateczności uid). */
  termsAcceptedBy: string | null;
  /** Kiedy, w milisekundach. */
  termsAcceptedAt: number | null;
  termsVersion: string | null;
}

/** Koperta odpowiedzi backendu v3. */
export interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}
